module Meevo.Plugins.Tippy {
    export interface Kiosk {
        kioskId: string;
        deviceId: string;
    }

    export interface Transaction {
        transactionId: string;
        state: TransactionStateEnum;
        tipLines: TipLine[];
    }

    export interface TipLine {
        employeeId: string;
        amount: number;
    }

    export enum TransactionStateEnum {
        Initial = 0,
        Pending,
        Confirmed,
        Failed,
        Canceled
    }
}